import { Loader2, X } from "lucide-react";
import { FILE_KINDS, isProcessing, statusOf } from "@/lib/files";
import { cn } from "@/lib/utils";

function Chip({ item, onRemove }) {
  const Icon = FILE_KINDS[item.kind]?.icon || FILE_KINDS.txt.icon;
  const uploading = item.status === "uploading";
  const failed = item.status === "error" || item.status === "failed" || (item.status === "completed" && !item.ai_readable);
  const note = item.status === "error" ? item.error : item.status === "failed" ? item.error_message : failed ? "ChatSleek can't read this file type yet" : null;
  const label = uploading ? `Uploading ${Math.round((item.progress || 0) * 100)}%` : isProcessing(item) ? "Reading…" : failed ? "Can't attach" : statusOf(item).label;
  return (
    <div
      className={cn("group flex max-w-[260px] items-center gap-2 rounded-xl border px-2.5 py-1.5", failed ? "border-rose-400/25 bg-rose-500/[0.06]" : "border-white/[0.09] bg-ink-800")}
      title={note || item.name}
      data-testid="attachment-chip"
      data-status={failed ? "error" : item.status}
    >
      {uploading || isProcessing(item) ? <Loader2 className="h-4 w-4 shrink-0 animate-spin text-zinc-400" /> : <Icon className={cn("h-4 w-4 shrink-0", failed ? "text-rose-300" : "text-zinc-300")} strokeWidth={1.6} />}
      <span className="min-w-0">
        <span className="block truncate text-[12.5px] text-zinc-100">{item.name}</span>
        <span className={cn("block truncate text-[11px]", failed ? "text-rose-300/90" : "text-zinc-500")}>{failed && note ? note : label}</span>
      </span>
      {onRemove && (
        <button type="button" onClick={() => onRemove(item.key)} aria-label={`Remove ${item.name}`} className="ml-0.5 rounded-md p-0.5 text-zinc-500 hover:bg-white/[0.08] hover:text-white" data-testid="attachment-chip-remove">
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}

export function AttachmentChips({ items, onRemove, className }) {
  if (!items?.length) return null;
  return (
    <div className={cn("flex flex-wrap gap-2", className)} data-testid="attachment-chips">
      {items.map((it) => (
        <Chip key={it.key || it.id} item={it} onRemove={onRemove} />
      ))}
    </div>
  );
}
